// extracted by mini-css-extract-plugin
export default {"new":"Badge_new__GIyWb"};